import React, { CSSProperties } from 'react';

export type HtmlTemplatePlayerContent = {
  id?: string;
  name?: string;
  htmlContent?: string;
  thumbnailUrl?: string;
};

type HtmlTemplateRendererProps = {
  content: HtmlTemplatePlayerContent | null;
  className?: string;
  style?: CSSProperties;
};

export function isHtmlTemplateContentType(contentType: string | undefined) {
  return contentType === 'html_template';
}

const HtmlTemplateRenderer: React.FC<HtmlTemplateRendererProps> = ({
  content,
  className = '',
  style,
}) => {
  const html = content?.htmlContent?.trim();
  if (!html) {
    return (
      <div
        className={`flex h-full w-full items-center justify-center bg-black text-white ${className}`}
        style={style}
      >
        <span>No HTML content</span>
      </div>
    );
  }

  return (
    <iframe
      title={content?.name || 'html-template'}
      srcDoc={html}
      sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
      className={`h-full w-full border-0 bg-black ${className}`}
      style={style}
    />
  );
};

export default HtmlTemplateRenderer;
